export default __webpack_public_path__ + "static/media/Growth Gamut Pvt Ltd V1.8458c52c.mp4";